import React from 'react';
import { Redirect } from 'react-router';

const Expo = (): JSX.Element => {
  return <Redirect to={{ pathname: '/' }} />;
};

export default Expo;
